module.exports = __webpack_public_path__ + "static/media/ajax-Loader.d49e0d2c.gif";